import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import { FormControl } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import Link from '../Link';

import { withQuery } from '../../hoc/withGraphql';
import { changePayout } from '../../actions/TransactionHistory/changePayout';
import { payoutChangeListing } from '../../actions/Payout/payoutChangeListing';
import messages from '../../locale/messages';

const Payouts = ({
    className,
    data: { loading, getPayouts },
    refetch,
    type,
    reservationId,
    defaultLabel = 'All payout methods',
    defaultValue,
    enableAddPayout = false,
    mode,
    handleResults,
    listId
}) => {

    const [payoutId, setPayoutId] = useState(defaultValue || null);
    const dispatch = useDispatch();
    const onChangePayoutId = useSelector(state => state.payoutChangeListing.onChangePayoutId);


    useEffect(() => {
        setPayoutId(defaultValue);
    }, [defaultValue]);

    const handleChange = (e) => {
        const selectedId = e.target.value;
        setPayoutId(selectedId);

        if (type === 'change') {
            dispatch(changePayout(selectedId, reservationId));
        } else {
            dispatch(payoutChangeListing(selectedId));
            handleResults && handleResults(mode, selectedId, listId);
        }
    };

    if (enableAddPayout && !loading && (!getPayouts || getPayouts.length === 0)) {
        return (
            <Link to="/user/payout">
                <FormattedMessage {...messages.transactionsAddPayout} />
            </Link>
        );
    }

    return (
        <FormControl
            componentClass="select"
            className={className}
            onChange={handleChange}
            value={payoutId || '0'}
        >
            <option value="0">{defaultLabel}</option>
            {!loading &&
                getPayouts &&
                getPayouts.map((item, index) => {
                    if (item.paymentMethod.id === 2 && item.isVerified) {
                        return (
                            <option value={item.id} key={index}>
                                ******{item.last4Digits}
                            </option>
                        );
                    } else if (item.isVerified) {
                        return (
                            <option value={item.id} key={index}>
                                {item.payEmail}
                            </option>
                        );
                    }
                    return null;
                })}
        </FormControl>
    );
};

Payouts.propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getPayouts: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                payEmail: PropTypes.string.isRequired,
                paymentMethod: PropTypes.shape({
                    id: PropTypes.number.isRequired,
                }),
                isVerified: PropTypes.bool,
                last4Digits: PropTypes.string,
            })
        ),
    }),
    refetch: PropTypes.any,
    type: PropTypes.string,
    reservationId: PropTypes.number,
    defaultLabel: PropTypes.string,
    defaultValue: PropTypes.number,
    enableAddPayout: PropTypes.bool,
    mode: PropTypes.string,
    handleResults: PropTypes.func,
    listId: PropTypes.number,
};

export default compose(
    withQuery(
        gql`
      query getPayouts {
        getPayouts {
          id
          methodId
          paymentMethod {
            id
            name
          }
          userId
          payEmail
          address1
          address2
          city
          state
          country
          zipcode
          currency
          default
          createdAt
          status
          last4Digits
          isVerified
        }
      }
    `,
        {
            options: {
                ssr: false,
                fetchPolicy: 'network-only',
            },
        }
    )
)(Payouts);